export class RecentHeadlines {
  pageSize: number;
  companyIds: Array<number>;
  recentHeadlines: boolean;
  retrieveDirection: string;
  retrieveLastTimeStamp: string;
  retrieveLastId: number;
  textSearch: string;
  headlineType: string;
  beginDate: string;
  endDate: string;
  companyFollowing: boolean;
  companyCategories: Array<number>;
  companyPrivate: boolean;
  companyPortfolio: boolean;
  companyInsights: boolean;

  constructor (data: any = {}) {
    this.pageSize = data.pageSize || null;
    this.companyIds = data.companyIds || [];
    this.recentHeadlines = data.recentHeadlines || false;
    this.retrieveDirection = data.retrieveDirection || null;
    this.retrieveLastTimeStamp = data.retrieveLastTimeStamp || null;
    this.retrieveLastId = data.retrieveLastId || null;
    this.textSearch = data.textSearch || null;
    this.headlineType = data.headlineType || null;
    this.beginDate = data.beginDate || null;
    this.endDate = data.endDate || null;
    this.companyFollowing = data.companyFollowing || null;
    this.companyCategories = data.companyCategories || [];
    this.companyPrivate = data.companyPrivate || null;
    this.companyPortfolio = data.companyPortfolio || null;
    this.companyInsights = data.companyInsights || null;
  }
}
